import React from "react"
import "./DischargeSummary.less"

export default class DischargeSummary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedCompositionIndex: 0,
            expandedSections: {}
        }
    }

    toggleSection = (sectionTitle) => {
        this.setState(prevState => ({
            expandedSections: {
                ...prevState.expandedSections,
                [sectionTitle]: !prevState.expandedSections[sectionTitle]
            }
        }))
    }

    componentDidMount() {
        console.log("DischargeSummary mounted")
        console.log(this.props.resources)
    }

    getAllCompositionResources = () => {
        const { resources } = this.props
        if (!resources || !Array.isArray(resources)) return []

        return resources.filter(resource =>
            resource.resource && resource.resource.resourceType === "Composition"
        )
    }

    getCompositionResource = () => {
        const compositions = this.getAllCompositionResources()
        if (compositions.length === 0) return null

        return compositions[this.state.selectedCompositionIndex]
    }

    handleCompositionChange = (e) => {
        this.setState({ selectedCompositionIndex: parseInt(e.target.value) })
    }

    formatDate = (dateString) => {
        if (!dateString) return "N/A"
        const date = new Date(dateString)
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }

    renderSection = (section) => {
        if (!section || !section.entry || section.entry.length === 0) return null

        const INITIAL_DISPLAY_COUNT = 5
        const isExpanded = this.state.expandedSections[section.title]
        const hasMoreItems = section.entry.length > INITIAL_DISPLAY_COUNT
        const displayEntries = isExpanded || !hasMoreItems
            ? section.entry
            : section.entry.slice(0, INITIAL_DISPLAY_COUNT)
        const hiddenCount = section.entry.length - INITIAL_DISPLAY_COUNT

        return (
            <div key={section.title} className="summary-section">
                <h4 className="section-title">{section.title}</h4>
                <div className="section-content">
                    <ul className="entry-list">
                        {displayEntries.map((entry, idx) => (
                            <li key={idx} className="entry-item">
                                <i className="glyphicon glyphicon-ok-circle text-success"></i>
                                <span className="entry-display">{entry.display}</span>
                            </li>
                        ))}
                    </ul>
                    {hasMoreItems && (
                        <button
                            className="btn btn-link view-more-btn"
                            onClick={() => this.toggleSection(section.title)}
                        >
                            {isExpanded ? (
                                <>
                                    <i className="glyphicon glyphicon-chevron-up"></i> View Less
                                </>
                            ) : (
                                <>
                                    <i className="glyphicon glyphicon-chevron-down"></i> View More ({hiddenCount} more items)
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        )
    }

    render() {
        const compositions = this.getAllCompositionResources()

        if (!compositions || compositions.length === 0) {
            return (
                <div className="container" style={{ marginTop: '20px' }}>
                    <div className="alert alert-warning">
                        <strong>No Data Available:</strong> No composition resource found.
                    </div>
                </div>
            )
        }

        const compositionData = compositions[this.state.selectedCompositionIndex]
        const composition = compositionData.resource
        const subject = composition.subject?.display || "Unknown Patient"
        const date = this.formatDate(composition.date)
        const status = composition.status || "N/A"

        return (
            <div className="container-fluid discharge-summary-container">
                {compositions.length > 1 && (
                    <div className="composition-selector">
                        <label htmlFor="composition-select">
                            <i className="glyphicon glyphicon-list-alt"></i> Select Document:
                        </label>
                        <select
                            id="composition-select"
                            className="form-control"
                            style={{ display: 'inline-block', width: 'auto' }}
                            value={this.state.selectedCompositionIndex}
                            onChange={this.handleCompositionChange}
                        >
                            {compositions.map((comp, idx) => {
                                const res = comp.resource
                                const title = res.title || "Untitled Document"
                                const date = this.formatDate(res.date)
                                const status = res.status || "unknown"
                                return (
                                    <option key={idx} value={idx}>
                                        {title} - {date} ({status})
                                    </option>
                                )
                            })}
                        </select>
                        <span className="composition-count">
                            {compositions.length} documents found
                        </span>
                    </div>
                )}

                <div className="summary-body">
                    {composition.identifier && (
                        <div className="identifier-section">
                            <p>
                                <span className="identifier-label">Document ID:</span>
                                {composition.identifier.value || "N/A"}
                            </p>
                            <p>
                                <span className="identifier-label">System:</span>
                                {composition.identifier.system || "N/A"}
                            </p>
                            {composition.custodian?.display && (
                                <p>
                                    <span className="identifier-label">Custodian:</span>
                                    {composition.custodian.display}
                                </p>
                            )}
                        </div>
                    )}

                    {composition.section && composition.section.length > 0 ? (
                        composition.section.map(section => this.renderSection(section))
                    ) : (
                        <div className="alert alert-info">
                            <i className="glyphicon glyphicon-info-sign"></i> No sections available in this composition.
                        </div>
                    )}
                </div>
            </div>
        )
    }
}